import matrix from './../matrix'
import XLSX from 'xlsx';
import Papa from "papaparse";
import MasterService from './../../../masterdata/services/masterdata.service';
import CONSTANT from './../../constants/constant'
import VueElementLoading from 'vue-element-loading'

export default {
  name: 'table',
  components: {
    matrix,
    VueElementLoading
  },
  props: ['data'],
  data: function() {
    return {
      opened: [],
      innerClassColumn: "col-12",
      matrixLabel: {},
      tabIndex: '',
      columnWidth: "col-md-4",
      isLoading:false,
      detailArr: [{
          type: "label",
          key: "Name",
          value: "abc"
        },
        {
          type: "detail",
          key: "Name",
          value: "abc"
        },
        {
          type: "table",
          key: ["header1", "header2", "header3"],
          value: [{
              "header1": "value1",
              "header2": "value2",
              "header3": "value3"
            },
            {
              "header1": "value1",
              "header2": "value2",
              "header3": "value3"
            }
          ]
        },
        {
          type: "matrix",
          key: [],
          value: []
        }, {
          type: "CityZoneMatrix",
          matrixHeaderCityArray: [],
          matrixTableDataCityArray: [],
          matrixHeaderZoneArray: [],
          matrixTableDataZoneArray: [],
          matrixLabel: ''
        },
      ],
      zones:[]
    }
  },
  computed: {},
  async mounted() {
    await this.getZonenamesdata();
  },
  methods: {
    checkCol(type) {
      type == 'heading' ? this.columnWidth = "col-12" : "col-4";
    },
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ['bg-primary', 'text-light']
      } else {
        return ['bg-light', 'text-info']
      }
    },
    emitEvent(data){
      if(data.type=="download"){
				this.fileview(data.value);
			}
    },
    fileview(index){
			var link = document.createElement('a');
			link.href = index;
			link.setAttribute('target','_blank');
			window.open(index, '_blank');
			link.remove();
			return true;
    },
    async downloadFile(value,index){
      this.isLoading = true
      let slabsequence;
      if (index != undefined) {
			   slabsequence = index + 1;
			}else{
			   slabsequence = 0;
			}

      let payload = {};
      let result;
      let resultArr = [];
      if (value.ComponentName == CONSTANT.RATE_TEMPLATE) {
        payload.ratetemplateid = value.ratetemplateid;
        payload.slabsequence = slabsequence;
        let countResult = await MasterService.getBaseRateCount(payload);
        let count = Number(countResult.data.data);
        let limit = 30000;
        let offset = 0;
        let tatlist = [];
        let loop =  Math.ceil(count / limit);
        for (let i = 0; i < loop; i++) {
          payload.limit = limit;
          payload.offset = offset;
          result = await MasterService.getBaserateForDownload(payload);
          resultArr = resultArr.concat(result.data.data)  
          offset = offset + limit;
              }
      } else if (value.ComponentName == CONSTANT.CONTRACT_TEMPLATE) {
        payload.ratetemplateid = value.ratetemplateid;
        payload.slabsequence = slabsequence;
						let countResult = await MasterService.getContractBaseRateCount(payload);
						let count = Number(countResult.data.data);
						let limit = 30000;
						let offset = 0;
						let tatlist = [];
						let loop =  Math.ceil(count / limit);
						for (let i = 0; i < loop; i++) {
							payload.limit = limit;
							payload.offset = offset;
							result = await MasterService.getContractBaserateForDownload(payload);
							resultArr = resultArr.concat(result.data.data)  
							offset = offset + limit;
       				 	}
      } else if (value.ComponentName == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
        payload.ratetemplateid = value.ratetemplateid;
        payload.slabsequence = slabsequence;
						let countResult = await MasterService.getClientContractBaserateCount(payload);
            if (countResult.data.code == 103) {
              this.isLoading = false;
              document.activeElement.blur();
							this.$alertify.error(countResult.data.message);
              console.log("countResult.data.message",countResult.data.message);
							return true;
						}
						let count = Number(countResult.data.data);
						let limit = 30000;
						let offset = 0;
						let tatlist = [];
						let loop =  Math.ceil(count / limit);
						for (let i = 0; i < loop; i++) {
							payload.limit = limit;
							payload.offset = offset;
              payload.servicetype = value.servicetype
							result = await MasterService.getClientContractBaserateForDownload(payload);
							resultArr = resultArr.concat(result.data.data)  
							offset = offset + limit;
       				 	}
      }
      this.isLoading = false;
      if (resultArr.length > 0) {
        let downloadArray = [];
        if (index == undefined) {
          if( resultArr[0].servicetype==2)
          {
            downloadArray= this.createMatrixforZonetoZone2(resultArr)
          }
          else{ 
            downloadArray = resultArr.map((el)=>{
              return {
               "Origin Region":el.originregion,
               "Origin State":el.originstate,
               "Origin City":el.origincity,
               "Origin Territory":el.originterritory,
               "Destination Region":el.destinationregion,
               "Destination State":el.destinationstate,
               "Destination City":el.destinationcity,
               "Destination Territory":el.destinationterritory,
               "Route Mode":el.travelmode,
               "Rate Basis":(el.ratebasis == 1)?"Weight":(el.ratebasis == 2)?"Quantity":"",
               "Rate Type" : 'Flat',
               "Rate per Basis":el.tariffrate,
              }
            });

          }
         
        }else{
          if( resultArr[0].servicetype==2)
          {
            downloadArray= this.createMatrixforZonetoZone2(resultArr)
          }
          else{
            downloadArray = resultArr.map((el)=>{
              return {
                  "Origin Region":el.originregion,
                  "Origin State":el.originstate,
                  "Origin City":el.origincity,
                  "Origin Territory":el.originterritory,
                  "Destination Region":el.destinationregion,
                  "Destination State":el.destinationstate,
                  "Destination City":el.destinationcity,
                  "Destination Territory":el.destinationterritory,
                  "Route Mode":el.travelmode,
                  "Rate Basis":(el.ratebasis == 1)?"Weight":(el.ratebasis == 2)?"Quantity":"",
                  "Rate Type" : 'Slab',
                  "Slab Type" :(el.slabtype == 1)?"Weight":(el.slabtype == 2)?"Quantity":"",
                  "Slab Break":el.lowerlimitvalue+" to "+el.higherlimitvalue,
                  "Rate per Basis":el.tariffrate
              }
            });
          }
     
        }
        var blob = new Blob([Papa.unparse(downloadArray)], { type: 'text/csv;charset=utf-8;' });
        var link = document.createElement("a");
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", 'Rates.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    createMatrixforZonetoZone2(data) {
			// Define the list of zones and initialize an empty matrix
			const matrix = {};
			// Initialize the matrix with zeros
			const matrixArray = this.zones.map((origin) => {
			  const row = { '': origin };
			  this.zones.forEach((destination) => {
				const foundItem = data.find(item => item.origincity === origin && item.destinationcity === destination);
				row[destination] = foundItem ? foundItem.tariffrate: null;
			  });
			  return row;
			});
			return matrixArray;
		  },
    async getZonenamesdata() {
      let inputpayload = {}
      let result = await MasterService.GetZoneNames(inputpayload);
      if (result.data.code == 200) {
        this.zones = result.data.data
      }
      else {
        this.$alertify.success("Zones Data not found");
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/shared/components/viewdetails/viewDetails.component.js